import { createContext as e, useContext as o } from "react";
const n = e({
  collapseOnMobile: !1,
  collapseOnTablet: !1,
  reverseOnCollapse: !1,
  mobileSpace: "none",
  tabletSpace: "none",
  desktopSpace: "none"
}), l = () => o(n);
export {
  n as ColumnsContext,
  l as useColumnsContext
};
